import { makeAutoObservable } from "mobx";

import { DEFAULT_DP_INFERENCE_CONFIG } from "../../constants/DpInferenceConfig";
import { DEFAULT_OCR_INFERENCE_CONFIG } from "../../constants/OcrInferenceConfig";
import { DpInferenceConfig } from "../../types/dpInferenceConfig";
import { OcrInferenceConfig } from "../../types/ocrInferenceConfig";

class ConfigStore {
  currentDPConfig: DpInferenceConfig = DEFAULT_DP_INFERENCE_CONFIG;
  currentOcrConfig: OcrInferenceConfig = DEFAULT_OCR_INFERENCE_CONFIG;

  constructor() {
    makeAutoObservable(this);
  }

  setDPConfig(config: DpInferenceConfig) {
    this.currentDPConfig = config;
  }

  setOcrConfig(config: OcrInferenceConfig) {
    this.currentOcrConfig = config;
  }

  resetDPConfig() {
    this.currentDPConfig = DEFAULT_DP_INFERENCE_CONFIG;
  }

  resetOcrConfig() {
    this.currentOcrConfig = DEFAULT_OCR_INFERENCE_CONFIG;
  }
}

export const configStore = new ConfigStore();
